import { compose } from 'recompose';
import StatusBar from './statusBar';

const enhance = compose();
export default enhance(StatusBar);
